module.exports = __webpack_public_path__ + "img/company_logo_full.11944dc5.svg";